<template>
  <div id="login">
    <div>
      <div id="logo"><a href="https://www.bigvisiontech.com/" target="_blank"><img src="../assets/images/logo.png" alt=""></a></div>
      <div id="projectList">
        <div class="projectList_main">
          <div class="projectList_top">请选择业务系统</div>
          <div class="projectList_list clearFix">
            <div class="projectList_l_li fl_l" v-for="(i, index) in scenesList" :key="index">
              <div>
                <img src="../assets/images/002.png" alt="" @click="jumpToUrl(i.hostname)">
              </div>
              <p>{{i.name}}</p>
            </div>
            <!-- <div class="projectList_l_li fl_l">
              <div>
                <img src="../assets/images/001.png" alt="" @click="jumpTo('manage')">
              </div>
              <p>亮柠檬门店系统</p>
            </div>
            <div class="projectList_l_li fl_l">
              <div>
                <img src="../assets/images/002.png" alt="" @click="jumpTo('crm')">
              </div>
              <p>比格威管理系统</p>
            </div>
            <div class="projectList_l_li fl_l">
              <div>
                <img src="../assets/images/002.png" alt="" @click="jumpTo('auth')">
              </div>
              <p>亮柠檬认证授权管理系统</p>
            </div>
            <div class="projectList_l_li fl_l">
              <div>
                <img src="../assets/images/002.png" alt="" @click="jumpTo('screen')">
              </div>
              <p>亮柠檬筛查管理系统</p>
            </div>
            <div class="projectList_l_li fl_l">
              <div>
                <img src="../assets/images/002.png" alt="" @click="jumpTo('filmReview')">
              </div>
              <p>亮柠檬阅片系统</p>
            </div> -->
          </div>
        </div>
      </div>

      <a href="https://www.bigvisiontech.com/" target="_blank" id="footer">苏州比格威医疗科技有限公司荣誉出品</a>
    </div>

  </div>
</template>
<script>
import { scenesAndHostname } from '../api/api'
import { getUrlSearch, setCodeToHeaders} from '@/js/common';
export default {
  name: 'Home',
  data() {
    return {
      scenesList: [],
      scenesList2: [
        {
          id: "22a8d804729943e090bfbf5fb00c9717",
          name: "亮柠檬门店系统",
          remark: "亮柠檬门店系统",
          createTime: "2021-02-09 13:24:15",
          code: "LNM",
          hostname: "https://blemon-dev.bigvisiontech.com"
        },
        {
          id: "41f3f1b4e58e4d2c87d11a211531cbcd",
          name: "亮柠檬阅片系统",
          remark: "亮柠檬阅片系统",
          createTime: "2021-02-25 13:50:11",
          code: "YP",
          hostname: "https://viewer-dev.bigvisiontech.com"
        },
        {
          id: "4ba1965fd6ab43b28a9b9d55b693267b",
          name: "亮柠檬筛查管理系统",
          remark: "亮柠檬筛查管理系统",
          createTime: "2021-02-19 10:59:00",
          code: "YXGL",
          hostname: "https://screening-dev.bigvisiontech.com"
        },
        {
          id: "77d3bbf939784692a635194c0316f0b1",
          name: "亮柠檬认证授权管理系统",
          remark: "平台使用，认证管理系统场景",
          createTime: "2021-02-07 15:55:09",
          code: "TYRZ",
          hostname: "https://auth-dev.bigvisiontech.com"
        },
        {
          id: "a2e14de60d584d98abf0f90e8ebdf840",
          name: "亮柠檬管理系统",
          remark: "亮柠檬管理系统",
          createTime: "2021-03-10 16:37:05",
          code: "KHGL",
          hostname: "https://admin-dev.bigvisiontech.com"
        },
        {
          id: "befea0fa1b1440a38cff3a5440d1f083",
          name: "比格威管理系统",
          remark: "比格威管理系统",
          createTime: "2021-03-04 20:08:42",
          code: "CRM",
          hostname: "https://crm-dev.bigvisiontech.com"
        }
      ]
    }
  },
  created() {
    console.log(this.$route.query.code)
    setCodeToHeaders(this.$route.query.code)
    this.api_scenesAndHostname()
  },
  async mounted() {
  },
  methods: {
    api_scenesAndHostname () {
      scenesAndHostname().then( res=>{
        // console.log('api_scenesAndHostname: ', res)
        this.scenesList = res
      })
    },
    jumpToUrl (url) {
      window.location.href = url
    },
    jumpTo(val) {
      var addr
      if (val == 'manage') {
        addr = process.env.VUE_APP_MANAGE_URL
      } else if (val == 'crm') {
        addr = process.env.VUE_APP_CRM_URL
      } else if (val == 'auth') {
        addr = process.env.VUE_APP_AUTH_URL
      } else if (val == 'screen') {
        addr = process.env.VUE_APP_SCREEN_URL
      } else if (val == 'filmReview') {
        addr = process.env.VUE_APP_FILMREVIEW_URL
      }
      window.location.href = addr
    }
  }
}
</script>
 
<style scoped>
@import url('../assets/css/base.css');
@import url('../assets/css/login.css');
</style>